import React, { Component } from 'react';
import { adminUserService } from 'services/adminUser';
import { alertActions } from 'redux/actions/alert-actions';
import { connect } from 'react-redux';

class TwoFactorSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totp_code: '',
            otpauth_uri: '',
            qr_image: '',
            secret: '',
            loading: true,
            submitting: false,
            submitted: false,
            remember_device: false,
            message: this.props.message || ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        adminUserService.twoFaSetup(this.props.challengeToken)
            .then((response) => {
                this.setState({
                    otpauth_uri: response.otpauth_uri || '',
                    qr_image: response.qr_image || '',
                    secret: response.secret || '',
                    message: response.message || this.state.message,
                    loading: false
                });
            })
            .catch((error) => {
                this.setState({ loading: false });
                this.props.dispatch(alertActions.error(error));
            });
    }

    handleChange(e) {
        const { name, type, checked, value } = e.target;
        this.setState({ [name]: type === 'checkbox' ? checked : value });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { totp_code, remember_device } = this.state;
        if (!totp_code || this.state.submitting) {
            return;
        }
        this.setState({ submitting: true });
        adminUserService.twoFaSetup(this.props.challengeToken, totp_code, remember_device)
            .then((response) => {
                this.setState({ submitting: false });
                if (response && response.token && this.props.onAuthenticated) {
                    this.props.onAuthenticated(response);
                }
            })
            .catch((error) => {
                this.setState({ submitting: false });
                this.props.dispatch(alertActions.error(error));
            });
    }

    render() {
        const { totp_code, qr_image, secret, loading, submitting, submitted, remember_device, message } = this.state;
        return (
            <div>
                {message && <p className="text-center">{message}</p>}
                {loading && <p className="text-center">Loading authenticator setup...</p>}
                {!loading && qr_image &&
                    <p className="text-center">
                        <img src={qr_image} alt="Authenticator QR code" style={{ maxWidth: '220px' }} />
                    </p>
                }
                {!loading && secret &&
                    <p className="text-center">
                        If you cannot scan the QR code, enter this secret manually:<br />
                        <strong>{secret}</strong>
                    </p>
                }
                <form name="twoFaSetupForm" onSubmit={this.handleSubmit}>
                    <div className={'form-group' + (submitted && !totp_code ? ' has-error' : '')}>
                        <input
                            type="text"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            placeholder="Enter 6-digit authenticator code"
                            className="form-control email_ctrl"
                            name="totp_code"
                            value={totp_code}
                            onChange={this.handleChange}
                        />
                        {submitted && !totp_code &&
                            <div className="help-block">Authenticator code is required.</div>
                        }
                    </div>
                    <div className="form-group">
                        <label>
                            <input
                                type="checkbox"
                                name="remember_device"
                                checked={remember_device}
                                onChange={this.handleChange}
                            />
                            {' '}Remember this device
                        </label>
                    </div>
                    <div className="form-group">
                        <button className="btn btn-default btn_login" disabled={submitting || loading}>
                            {submitting ? 'VERIFYING...' : 'VERIFY AND CONTINUE'}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default connect()(TwoFactorSetup);
